import { Box, Drawer, IconButton } from '@mui/material';
import { NavLink } from 'react-router-dom';
import ListIcon from '@mui/icons-material/List';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { getGlobalCookie } from '../../utils';
import { canManageTokens } from '../../AIChatBot/tokenAccess';
import { hanwahaInstance, jetStreamInstance, testLessor } from '../../shared_elements';

const SettingNav = () => {
    const [open, setOpen] = useState(false);
    const { permission } = useSelector((state) => state.leases);
    const canViewAiConsent = canManageTokens(permission);
    const settingNavLinks = [
        { path: "/settings/party-role", label: "Party Role" },
        { path: "/settings/clause", label: "Clause" },
        { path: "/settings/security-against", label: "Security Against" },
        { path: "/settings/cashflow-categories", label: "Cashflow Categories" },
        { path: "/settings/calendar", label: "Calendar" },
        { path: "/settings/insurance-type", label: "Insurance Type" },
        { path: "/settings/rate-account-type", label: "Rate Account Type" },
        ...(testLessor ? [{ path: "/settings/working-group", label: "Working Group" }] : []),
        { path: "/settings/additional-tax-type", label: "Additional Tax Type" },
        {path: "/settings/invoice-configuration", label: "Invoice Title Configuration"},
        ...(canViewAiConsent
            ? [{ path: "/settings/ai-consent", label: "AI Chat Assistant Consent" }]
            : []),
        // { path: "/settings/custom-fields", label: "Custom Fields" },
        ...((jetStreamInstance || hanwahaInstance)
            ? [
                { path: "/settings/chart-of-account", label: "Chart of Account" },
                { path: "/settings/product-services", label: "Product & Services" },
            ]
            : []),
        ...(hanwahaInstance
            ? [{ path: "/settings/classes", label: "Classes" }]
            : []),
        { path: "/settings/alert-notification", label: "Alert & Notifications" },
        // {path: "/settings/sales", label: "Sales"}
    ];
    const toggleDrawer = (newOpen) => () => {
        setOpen(newOpen);
    };
    return (
        <>
            {/* {isMobile ? */}
                {/* <Box className="mobile-pry-container" sx={{ display: { md: "none", xs: "block" } }} style={{ position: "absolute", marginBottom: "0px" }}> */}
                <Box className="mobile-pry-container" sx={{ display: { xs: "block" } }} style={{ position: "absolute", marginBottom: "0px" }}>
                    <IconButton onClick={toggleDrawer(true)}>
                        <ListIcon />
                    </IconButton>
                    <Drawer anchor="left" open={open} onClose={toggleDrawer(false)} PaperProps={{ sx: { width: 280, backgroundColor: "#6b5eb0", color: "#fff", overflowY: "auto" } }}>
                        <Box sx={{ py: 1 }}>
                            {settingNavLinks.map(({ path, label }) => (
                                <NavLink key={path} to={path} onClick={() => setOpen(false)} className={({ isActive }) => (isActive ? "active" : "")} style={{ display: "block", padding: "12px 20px", color: "#fff", textDecoration: "none", fontFamily: "Roboto", fontSize: "14px", borderBottom: "1px solid #fff" }}> {label}</NavLink>
                            ))}
                        </Box>
                    </Drawer>
                </Box>
                <div className='leases-nav'>
                    {settingNavLinks.map(({ path, label }) => (
                        <div className='leases-nav-link' key={path}>
                            <NavLink to={path} className={({ isActive }) => (isActive ? "active" : "")}> {label} </NavLink> </div>
                    ))}
                </div>
            {/* } */}
        </>
    );
};

export default SettingNav;
